export const ChevronDownIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 9l6 6 6-6"
    ></path>
  </svg>
);

export const ChevronRightIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 18l6-6-6-6"
    ></path>
  </svg>
);

export const RoundLine = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="203"
    height="44"
    fill="none"
    viewBox="0 0 203 44"
  >
    <path
      stroke="#FB7676"
      strokeWidth="8"
      d="M3.5 40.498C41 9.5 97.954-7.712 201.5 14.998"
    ></path>
  </svg>
);

export const ShareIcon = ({ className = "stroke-current text-[#222528]" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.583 7a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM5.583 12.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM14.583 17.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM7.525 11.133l5.123 2.985M12.64 5.883L7.525 8.868"
    ></path>
  </svg>
);

export const FileIcon = ({ classname }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classname}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1447 11.5566H11.6863C12.0517 11.5566 12.3546 11.2596 12.3546 10.8906C12.3546 10.5126 12.0517 10.2156 11.6863 10.2156H10.1447V8.65858C10.1447 8.28958 9.85067 7.99258 9.48532 7.99258C9.11998 7.99258 8.81701 8.28958 8.81701 8.65858V10.2156H7.28433C6.91899 10.2156 6.61602 10.5126 6.61602 10.8906C6.61602 11.2596 6.91899 11.5566 7.28433 11.5566H8.81701V13.1136C8.81701 13.4826 9.11998 13.7796 9.48532 13.7796C9.85067 13.7796 10.1447 13.4826 10.1447 13.1136V11.5566ZM16.2543 7.32305C16.4637 7.32063 16.6918 7.318 16.899 7.318C17.1218 7.318 17.3 7.498 17.3 7.723V14.959C17.3 17.191 15.5089 19 13.2901 19H6.20594C3.88911 19 2 17.101 2 14.761V5.059C2 2.827 3.8 1 6.01881 1H10.7772C11.0089 1 11.1871 1.189 11.1871 1.414V4.312C11.1871 5.959 12.5327 7.309 14.1634 7.318C14.5443 7.318 14.8801 7.32085 15.1739 7.32334C15.4025 7.32528 15.6058 7.327 15.7851 7.327C15.912 7.327 16.0764 7.3251 16.2543 7.32305ZM16.498 6.00875C15.7655 6.01145 14.902 6.00875 14.2809 6.00245C13.2954 6.00245 12.4836 5.18255 12.4836 4.18715V1.81475C12.4836 1.42685 12.9496 1.23425 13.2161 1.51415C13.6982 2.02052 14.3608 2.71653 15.0204 3.4094C15.6785 4.10072 16.3336 4.7889 16.8036 5.28245C17.0638 5.55515 16.8731 6.00785 16.498 6.00875Z"
    />
  </svg>
);

export const UnsplashIcon = ({ classname = "w-6 h-6" }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classname}
  >
    <path d="M5 4.5V0H11V4.5H5ZM11 7H16V16H0V7H5V11.5H11V7Z" />
  </svg>
);

export const LinkIcon = ({ classname = "w-6 h-6" }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classname}
  >
    <path
      d="M8.33203 10.834C8.68991 11.3124 9.1465 11.7083 9.67082 11.9947C10.1952 12.2812 10.775 12.4516 11.3709 12.4942C11.9669 12.5369 12.565 12.4509 13.1248 12.2421C13.6846 12.0333 14.193 11.7065 14.6154 11.284L17.1154 8.78396C17.8744 7.99811 18.2943 6.9456 18.2848 5.85312C18.2753 4.76063 17.8371 3.71558 17.0646 2.94304C16.2921 2.17051 15.247 1.73231 14.1545 1.72281C13.062 1.71332 12.0095 2.1333 11.2237 2.89229L9.79036 4.31729"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.953 8.67092C12.5951 8.19248 12.1385 7.7966 11.6142 7.51014C11.0898 7.22368 10.51 7.05333 9.91409 7.01065C9.31814 6.96796 8.71998 7.05395 8.16018 7.26277C7.60038 7.47159 7.09204 7.79837 6.66963 8.22092L4.16963 10.7209C3.41064 11.5068 2.99066 12.5593 3.00016 13.6518C3.00965 14.7442 3.44785 15.7893 4.22039 16.5618C4.99292 17.3344 6.03797 17.7726 7.13046 17.7821C8.22295 17.7916 9.27546 17.3716 10.0613 16.6126L11.4863 15.1876"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconsIcon = ({ classname = "w-6 h-6" }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classname}
  >
    <path
      d="M5.41667 8.33333C7.0275 8.33333 8.33333 7.0275 8.33333 5.41667C8.33333 3.80584 7.0275 2.5 5.41667 2.5C3.80584 2.5 2.5 3.80584 2.5 5.41667C2.5 7.0275 3.80584 8.33333 5.41667 8.33333Z"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08203 17.4993H8.7487L5.41536 11.666L2.08203 17.4993Z"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 2.5L17.5013 8.33333"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 8.33333L17.5013 2.5"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 11.666H17.5013V17.4993H11.668V11.666Z"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrossIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      d="M12.665 3.333l-9.333 9.333M3.332 3.333l9.333 9.333"
    ></path>
  </svg>
);

export const SearchIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9984 21.0004L16.6484 16.6504"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CoursesIconRect = ({
  className,
  style,
  fillPrimary,
  fillSecondary,
}) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <rect width="48" height="48" rx="8" fill="#16191B" />
    <rect
      x="10.0039"
      y="13.5"
      width="25.2"
      height="17.5"
      rx="2"
      fill={fillSecondary || "#404A51"}
    />
    <rect
      x="12.8047"
      y="16.2988"
      width="25.2"
      height="17.5"
      rx="2"
      fill={fillPrimary || "currentColor"}
    />
    <path
      d="M29.6055 25.0492L22.6055 21.1992V28.8992L29.6055 25.0492Z"
      fill={fillPrimary ? "white" : "#16191B"}
    />
  </svg>
);

export const PremiumContentIconRect = ({ className, style }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <rect width="48" height="48" rx="8" fill="#16191B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.4419 18.6293V20.4182C32.4513 21.0454 33.9154 22.8645 33.9154 25.0371V30.7968C33.9154 33.4866 31.6855 35.6673 28.9363 35.6673H19.0623C16.3119 35.6673 14.082 33.4866 14.082 30.7968V25.0371C14.082 22.8645 15.5473 21.0454 17.5555 20.4182V18.6293C17.5674 15.1512 20.4481 12.334 23.9809 12.334C27.5611 12.334 30.4419 15.1512 30.4419 18.6293ZM24.0046 14.3629C26.4111 14.3629 28.3672 16.2758 28.3672 18.6293V20.1667H19.6301V18.6062C19.6419 16.2642 21.598 14.3629 24.0046 14.3629ZM25.0352 29.1981C25.0352 29.7662 24.5728 30.2184 23.9919 30.2184C23.4229 30.2184 22.9605 29.7662 22.9605 29.1981V26.6243C22.9605 26.0678 23.4229 25.6157 23.9919 25.6157C24.5728 25.6157 25.0352 26.0678 25.0352 26.6243V29.1981Z"
      fill="currentColor"
    />
  </svg>
);

export const QoohooIconRect = ({ className, style }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <rect width="48" height="48" rx="8" fill="#16191B" />
    <path
      d="M18.5005 15.7014C19.9095 15.7014 21.0518 14.558 21.0518 13.1476C21.0518 11.7371 19.9095 10.5938 18.5005 10.5938C17.0915 10.5938 15.9492 11.7371 15.9492 13.1476C15.9492 14.558 17.0915 15.7014 18.5005 15.7014Z"
      fill="currentColor"
    />
    <path
      d="M29.6353 17.8731C28.127 16.3861 26.2947 15.6426 24.1424 15.6426C21.9859 15.6426 20.1619 16.3861 18.6619 17.8731C17.162 19.3602 16.4141 21.1919 16.4141 23.3643C16.4141 25.5367 17.162 27.3685 18.6619 28.8556C20.1619 30.3426 21.9859 31.0861 24.1424 31.0861C26.2988 31.0861 28.127 30.3426 29.6353 28.8556C29.6644 28.8265 29.6893 28.7974 29.7184 28.7683L28.1561 37.4662H31.8956V23.3643C31.8998 21.1919 31.1436 19.3602 29.6353 17.8731ZM27.8445 27.0944C26.8473 28.0913 25.6133 28.5939 24.1424 28.5939C22.6923 28.5939 21.4707 28.0954 20.4694 27.0944C19.4722 26.0975 18.9694 24.8514 18.9694 23.3643C18.9694 21.8773 19.468 20.6312 20.4694 19.6343C21.4666 18.6374 22.6923 18.1348 24.1424 18.1348C25.6133 18.1348 26.8473 18.6333 27.8445 19.6343C28.8417 20.6312 29.3445 21.8773 29.3445 23.3643C29.3403 24.8514 28.8417 26.0975 27.8445 27.0944Z"
      fill="currentColor"
    />
  </svg>
);

export const SlotBookingIconRect = ({ className, style }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <rect width="40" height="40" rx="8" fill="#16191B" />
    <path
      d="M12.6016 18.1131H28.0572"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8313 11.6934V14.5469"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8235 11.6934V14.5469"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9988 13.0625H16.6566C14.1101 13.0625 12.5195 14.4811 12.5195 17.0886V24.9358C12.5195 27.5844 14.1101 29.0357 16.6566 29.0357H23.9908C26.5453 29.0357 28.1278 27.609 28.1278 25.0014V17.0886C28.1359 14.4811 26.5533 13.0625 23.9988 13.0625Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TelegramIconRect = ({ className, style }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <rect width="48" height="48" rx="8" fill="#16191B" />
    <g clipPath="url(#clip0_1334_5334)">
      <path
        d="M24 38C31.732 38 38 31.732 38 24C38 16.268 31.732 10 24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3343 23.852C20.4155 22.0738 23.137 20.9015 24.4987 20.3352C28.3867 18.718 29.1946 18.4371 29.7211 18.4278C29.837 18.4258 30.0959 18.4545 30.2636 18.5906C30.4053 18.7055 30.4442 18.8608 30.4629 18.9697C30.4815 19.0787 30.5048 19.3269 30.4863 19.5209C30.2756 21.7346 29.364 27.1067 28.9002 29.5862C28.7039 30.6353 28.3175 30.9871 27.9434 31.0215C27.1304 31.0963 26.513 30.4842 25.7256 29.968C24.4934 29.1603 23.7973 28.6575 22.6013 27.8693C21.219 26.9585 22.1151 26.4578 22.9028 25.6397C23.109 25.4255 26.6911 22.1673 26.7604 21.8717C26.7691 21.8348 26.7771 21.697 26.6953 21.6242C26.6134 21.5515 26.4926 21.5763 26.4054 21.5961C26.2818 21.6242 24.3134 22.9252 20.5001 25.4993C19.9414 25.883 19.4353 26.0699 18.9819 26.0601C18.482 26.0493 17.5205 25.7775 16.8056 25.5451C15.9289 25.2601 15.2321 25.1094 15.2927 24.6254C15.3244 24.3733 15.6715 24.1155 16.3343 23.852Z"
        fill="#16191B"
      />
    </g>
    <defs>
      <clipPath id="clip0_1334_5334">
        <rect
          x="10"
          y="10"
          width="28"
          height="28"
          rx="14"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WhatsappIconRect = ({ className, style }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <rect width="48" height="48" rx="8" fill="#16191B" />
    <path
      d="M11.3672 36.553L13.1584 30.0243C12.0547 28.1118 11.4736 25.9425 11.4737 23.7344C11.4737 16.7943 17.1266 11.1406 24.0667 11.1406C27.4376 11.1406 30.5954 12.4551 32.984 14.8296C34.1564 15.9968 35.0861 17.3846 35.7194 18.913C36.3527 20.4414 36.6771 22.08 36.6737 23.7344C36.6737 30.6745 31.0201 36.3274 24.08 36.3274C21.9699 36.3274 19.9002 35.797 18.0553 34.7882L11.3672 36.5537V36.553Z"
      fill="#16191B"
    />
    <path
      d="M10.918 37.0036L12.7761 30.2493C11.6341 28.268 11.0343 26.0208 11.037 23.7339C11.0237 16.5278 16.8765 10.6758 24.0686 10.6758C27.5585 10.6758 30.8361 12.0291 33.3047 14.4978C34.5212 15.7079 35.4853 17.1474 36.1414 18.7328C36.7975 20.3182 37.1324 22.0181 37.1267 23.7339C37.1267 30.926 31.274 36.778 24.0819 36.778C21.8924 36.778 19.7559 36.2336 17.8449 35.1859L10.918 37.0036ZM18.1505 32.837L18.548 33.0758C20.2197 34.0649 22.1262 34.5874 24.0686 34.5886C30.0404 34.5886 34.9109 29.7189 34.9109 23.7463C34.9109 20.8538 33.7831 18.1207 31.7391 16.0774C30.7339 15.0666 29.5387 14.2647 28.2222 13.718C26.9058 13.1712 25.4941 12.8904 24.0686 12.8917C18.0836 12.8917 13.214 17.7621 13.214 23.7339C13.214 25.7771 13.7841 27.7814 14.8722 29.5066L15.1242 29.918L14.0229 33.9251L18.1497 32.837H18.1505Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8177 18.2682C20.5789 17.7237 20.3137 17.7105 20.0881 17.7105C19.889 17.6973 19.6759 17.6973 19.4504 17.6973C19.2388 17.6973 18.8803 17.7766 18.5746 18.1087C18.2697 18.44 17.4336 19.2233 17.4336 20.8286C17.4336 22.4347 18.6018 23.9872 18.7605 24.1995C18.9199 24.4118 21.016 27.8084 24.334 29.1228C27.0951 30.2109 27.652 29.9986 28.2486 29.9317C28.8459 29.8656 30.1728 29.1493 30.452 28.3793C30.7165 27.6233 30.7165 26.9598 30.6379 26.8268C30.5578 26.6946 30.3323 26.6145 30.0141 26.4418C29.682 26.2832 28.0899 25.4867 27.7843 25.3802C27.4794 25.2744 27.267 25.2215 27.0547 25.5396C26.8424 25.8717 26.2186 26.6013 26.0203 26.8136C25.8336 27.0259 25.6345 27.0524 25.3164 26.8929C24.9843 26.7343 23.9358 26.3889 22.689 25.2744C21.7199 24.411 21.0697 23.3369 20.8706 23.0188C20.6847 22.6867 20.8441 22.514 21.0168 22.3546C21.163 22.2092 21.3481 21.9704 21.5076 21.7845C21.667 21.5978 21.7199 21.4524 21.8397 21.24C21.9455 21.0277 21.8926 20.8286 21.8133 20.6699C21.7331 20.5237 21.1094 18.9176 20.8177 18.2674V18.2682Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIconAlt = ({ color, opacity, className }) => (
  <svg
    className={className}
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      opacity={opacity}
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        opacity={opacity}
        d="M8.167 14.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333ZM16.5 16.5l-3.625-3.625"
      />
    </g>
  </svg>
);

export const EditIcon = ({ fill = "#16191B", className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0487 5.15272L5.1208 14.0806L2.26673 14.3977C1.88391 14.4406 1.56107 14.1178 1.60393 13.7349L1.92105 10.8809L10.8489 1.95296C11.3175 1.48443 12.0774 1.48443 12.546 1.95296L14.0487 3.45571C14.5172 3.92424 14.5172 4.68419 14.0487 5.15272ZM11.3746 6.53547L9.46904 4.6299L2.79527 11.3008L2.55814 13.4464L4.70369 13.2093L11.3746 6.53547ZM13.403 4.10137L11.9003 2.59863C11.7917 2.49007 11.6089 2.48435 11.4975 2.59863L10.1147 3.98138L12.0203 5.88695L13.403 4.5042C13.5144 4.39564 13.5144 4.21279 13.403 4.10137Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
    </svg>
  );
};

export const QoohooIcon = ({ className, color="#16191B" }) => {
  return (
    <svg
      className={className}
      width="96"
      height="28"
      viewBox="0 0 96 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.42697 6.08371C3.07064 6.08371 3.68795 5.82782 4.14309 5.37232C4.59824 4.91682 4.85394 4.29903 4.85394 3.65486C4.85394 3.01069 4.59824 2.3929 4.14309 1.9374C3.68795 1.48191 3.07064 1.22601 2.42697 1.22601C1.7833 1.22601 1.16599 1.48191 0.710842 1.9374C0.255698 2.3929 0 3.01069 0 3.65486C0 4.29903 0.255698 4.91682 0.710842 5.37232C1.16599 5.82782 1.7833 6.08371 2.42697 6.08371ZM24.2414 6.05555C22.1815 6.05555 20.4459 6.76136 19.0068 8.18781C17.5815 9.59981 16.8622 11.3508 16.8622 13.4268C16.8622 15.5027 17.5815 17.2537 19.0065 18.6798C20.4322 20.1059 22.1815 20.8121 24.2417 20.8121C26.302 20.8121 28.0372 20.1062 29.4766 18.6798C30.9157 17.2537 31.6354 15.5168 31.6354 13.4268C31.6354 11.3367 30.916 9.59981 29.4766 8.17374C28.0372 6.76136 26.2876 6.05555 24.2414 6.05555ZM27.7696 16.9851C26.8096 17.9454 25.6386 18.4116 24.2414 18.4116C22.859 18.4116 21.6876 17.9314 20.7424 16.9851C19.7828 16.0251 19.3171 14.8391 19.3171 13.4268C19.3171 12.0003 19.7969 10.8143 20.7424 9.86805C21.7017 8.9077 22.859 8.44198 24.2417 8.44198C25.6386 8.44198 26.824 8.92216 27.7692 9.86805C28.7288 10.8284 29.1945 12.0148 29.1945 13.4268C29.1945 14.8528 28.7292 16.0392 27.7696 16.9851ZM7.81698 6.05555C5.75709 6.05555 4.0215 6.76136 2.58247 8.18781C1.15712 9.59981 0.437413 11.3508 0.437413 13.4268C0.437413 15.5027 1.15712 17.2537 2.58247 18.6798C4.00743 20.1059 5.75709 20.8121 7.81736 20.8121C9.87725 20.8121 11.6128 20.1062 13.0522 18.6798L13.137 18.5949L11.641 26.8984H15.211V13.4268C15.211 11.3508 14.4913 9.59981 13.0522 8.17374C11.6128 6.76136 9.87763 6.05555 7.81698 6.05555ZM11.3452 16.9851C10.3852 17.9454 9.21419 18.4116 7.81698 18.4116C6.43459 18.4116 5.26321 17.9314 4.31805 16.9851C3.35844 16.0251 2.8927 14.8391 2.8927 13.4268C2.8927 12.0003 3.37251 10.8143 4.31805 9.86805C5.27728 8.9077 6.43459 8.44198 7.81736 8.44198C9.21419 8.44198 10.3993 8.92216 11.3448 9.86805C12.3044 10.8284 12.7698 12.0148 12.7698 13.4268C12.7842 14.8528 12.3048 16.0392 11.3452 16.9851ZM40.6661 6.05555C38.6062 6.05555 36.8706 6.76136 35.4312 8.18781C34.0063 9.61389 33.2865 11.3508 33.2865 13.4408C33.2865 15.5309 34.0063 17.2678 35.4312 18.6939C36.8566 20.1203 38.6062 20.8261 40.6661 20.8261C42.7264 20.8261 44.462 20.1203 45.901 18.6939C47.3404 17.2678 48.0601 15.5309 48.0601 13.4408C48.0601 11.3508 47.3404 9.61389 45.901 8.18781C44.462 6.76136 42.7123 6.05555 40.6661 6.05555ZM44.1935 16.9851C43.2343 17.9454 42.0629 18.4116 40.6661 18.4116C39.2833 18.4116 38.1123 17.9314 37.1668 16.9851C36.2072 16.0251 35.7415 14.8391 35.7415 13.4268C35.7415 12.0003 36.2213 10.8143 37.1668 9.86805C38.1264 8.9077 39.2833 8.44198 40.6661 8.44198C42.0629 8.44198 43.2484 8.92216 44.1935 9.86805C45.1532 10.8284 45.6189 12.0148 45.6189 13.4268C45.6189 14.8528 45.1391 16.0392 44.1935 16.9851ZM57.2456 6.05555C55.2138 6.05555 53.69 6.84621 52.7023 8.44198V1H50.2611V20.4449H52.7023V13.0029C52.7023 11.4353 53.0692 10.2634 53.817 9.51496C54.5649 8.75246 55.5385 8.38529 56.7662 8.38529C57.8524 8.38529 58.6991 8.69615 59.3199 9.33156C59.9408 9.9529 60.2514 10.8425 60.2514 11.9862V20.459H62.6923V11.831C62.6923 10.0518 62.1984 8.65391 61.2106 7.60871C60.2088 6.56389 58.8968 6.05555 57.2456 6.05555ZM71.991 6.05555C69.9308 6.05555 68.1952 6.76136 66.7561 8.18781C65.3308 9.61389 64.6111 11.3508 64.6111 13.4408C64.6111 15.5309 65.3308 17.2678 66.7561 18.6939C68.1811 20.1203 69.9308 20.8261 71.991 20.8261C74.0509 20.8261 75.7865 20.1203 77.2259 18.6939C78.665 17.2678 79.3847 15.5309 79.3847 13.4408C79.3847 11.3508 78.665 9.61389 77.2259 8.18781C75.7865 6.76136 74.0509 6.05555 71.991 6.05555ZM75.5185 16.9851C74.5589 17.9454 73.3879 18.4116 71.991 18.4116C70.6083 18.4116 69.4369 17.9314 68.4917 16.9851C67.5321 16.0251 67.0664 14.8391 67.0664 13.4268C67.0664 12.0003 67.5462 10.8143 68.4917 9.86805C69.451 8.9077 70.6083 8.44198 71.991 8.44198C73.3879 8.44198 74.5729 8.92216 75.5185 9.86805C76.4781 10.8284 76.9435 12.0148 76.9435 13.4268C76.9579 14.8528 76.4781 16.0392 75.5185 16.9851ZM93.6503 8.18743C92.2109 6.76136 90.4612 6.05555 88.4154 6.05555C86.3551 6.05555 84.6196 6.76136 83.1805 8.18781C81.7552 9.61389 81.0359 11.3508 81.0359 13.4408C81.0359 15.5309 81.7552 17.2678 83.1805 18.6939C84.6055 20.1203 86.3551 20.8261 88.4154 20.8261C90.4753 20.8261 92.2109 20.1203 93.6503 18.6939C95.0897 17.2678 95.809 15.5309 95.809 13.4408C95.809 11.3508 95.0897 9.59943 93.6503 8.18743ZM91.9428 16.9851C90.9836 17.9454 89.8122 18.4116 88.4154 18.4116C87.0326 18.4116 85.8613 17.9314 84.9161 16.9851C83.9565 16.0251 83.4908 14.8391 83.4908 13.4268C83.4908 12.0003 83.9706 10.8143 84.9161 9.86805C85.8753 8.9077 87.0326 8.44198 88.4154 8.44198C89.8122 8.44198 90.9977 8.92216 91.9428 9.86805C92.9025 10.8284 93.3682 12.0148 93.3682 13.4268C93.3682 14.8528 92.9025 16.0392 91.9428 16.9851Z"
        fill={color}
      />
    </svg>
  );
};


export const ArrowIcon = ({ className, color="#16191B" }) => (
  <svg
    width="20"
    height="20"
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 10L15 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.16663L15.8333 9.99996L10 15.8333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GiftIcon = ({ className, color = "#16191B" }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3806_6233)">
      <path
        d="M5.95312 2.15L7.04063 4H7H4.75C4.05937 4 3.5 3.44063 3.5 2.75C3.5 2.05937 4.05937 1.5 4.75 1.5H4.81875C5.28437 1.5 5.71875 1.74688 5.95312 2.15ZM2 2.75C2 3.2 2.10937 3.625 2.3 4H1C0.446875 4 0 4.44687 0 5V7C0 7.55313 0.446875 8 1 8H15C15.5531 8 16 7.55313 16 7V5C16 4.44687 15.5531 4 15 4H13.7C13.8906 3.625 14 3.2 14 2.75C14 1.23125 12.7687 0 11.25 0H11.1812C10.1844 0 9.25938 0.528125 8.75313 1.3875L8 2.67188L7.24687 1.39062C6.74062 0.528125 5.81562 0 4.81875 0H4.75C3.23125 0 2 1.23125 2 2.75ZM12.5 2.75C12.5 3.44063 11.9406 4 11.25 4H9H8.95938L10.0469 2.15C10.2844 1.74688 10.7156 1.5 11.1812 1.5H11.25C11.9406 1.5 12.5 2.05937 12.5 2.75ZM1 9V14.5C1 15.3281 1.67188 16 2.5 16H7V9H1ZM9 16H13.5C14.3281 16 15 15.3281 15 14.5V9H9V16Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3806_6233">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WarningIcon = ({ className, color = "#EE9B40" }) => (
  <svg
    className={className}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99336 1.5C8.37826 0.833334 9.34051 0.833333 9.72541 1.5L16.6536 13.5C17.0385 14.1667 16.5574 15 15.7876 15H1.93118C1.16138 15 0.680254 14.1667 1.06515 13.5L7.99336 1.5Z"
      fill={color}
    />
    <path
      d="M8.85742 5.39844V9.89844"
      stroke="#FFF9F1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.85742 12.3047H8.86768"
      stroke="#FFF9F1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilledCross = ({ className, color = "#16191B" }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.94724 8.33437L12.0001 10.3882L14.0528 8.33437C14.4986 7.88854 15.2198 7.88854 15.6656 8.33437C16.1115 8.78019 16.1115 9.50142 15.6656 9.94724L13.613 12.0011L15.6653 14.0525C16.1112 14.4983 16.1112 15.2195 15.6653 15.6653C15.4432 15.889 15.151 16.0001 14.8589 16.0001C14.5667 16.0001 14.2746 15.889 14.0525 15.6653L12.0001 13.6139L9.94754 15.6653C9.72539 15.889 9.43325 16.0001 9.14111 16.0001C8.84896 16.0001 8.55682 15.889 8.33467 15.6653C7.88885 15.2195 7.88885 14.4983 8.33467 14.0525L10.3872 12.0011L8.33437 9.94724C7.88854 9.50142 7.88854 8.78019 8.33437 8.33437C8.78019 7.88854 9.50142 7.88854 9.94724 8.33437Z"
      fill={color}
    />
  </svg>
);
